import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Input } from '@angular/core';
import * as JSZip from 'jszip';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ErrorLog, ErrorLogFile } from 'src/app/models/errorLog';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { UtilsService } from 'src/app/services/utils.service';
import * as fileSaver from 'file-saver';
import { PendingCalculationType } from 'src/app/models/pendingCalculation';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';

@Component({
  selector: 'app-error-logs-display',
  templateUrl: './error-logs-display.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class ErrorLogsDisplayComponent{

  @Input() errorLogsByCalcType: Map<String, ErrorLog[]>;


  constructor(public bsModalRef : BsModalRef,
    public http : HttpClient,
    public endpointService:EndpointsService,
    private modalService : ModalControlService,
    private confirmationModalService : ModalConfirmationService)
  {
  }

  downloadLogs(calculationType: string){
    this.http.get<ErrorLogFile[][]>(this.endpointService.downloadErrorLogs + `/${calculationType}`, {
      headers: this.endpointService.httpOptions.headers,
    })
    .subscribe({
      error: (error) => {
        if (error && error.status == 504){
          return;
        }
        if (error && error.status == 409){
          this.modalService.showMesssageModal(
            'Error Downloading',
            'You are not authorized to download the Error Logs'
          );
          return;
        }
        this.modalService.showMesssageModal(
          'Error Downloading',
          'There was an error downloading the Error Logs'
        );
      }
    });
  }


  getAllErrorLogsRequest(){
    return this.http.get<ErrorLog[]>(this.endpointService.getAllErrorLogs, this.endpointService.httpOptions);
  }

  deleteAllErrorLogsRequest(){

    this.http.delete<void>(this.endpointService.deleteAllErrorLogs, this.endpointService.httpOptions)
    .subscribe({
      next: () => {
        this.close();
        this.modalService.showMesssageModal(
          'Error Logs',
          'Error logs deleted successfully'
        );
      },
      error: error => {
        this.modalService.showMesssageModal(
          'Error Deleting',
          'There was an error deleting the Error Logs'
        );
      }
    });
  }

  deleteAllErrorLogs(){
    this.confirmationModalService.showMesssageConfirmationModal
    (
      "Error Logs",
      "This will delete all error logs permanently. Are you sure you want to continue?",
      "Yes",
      "No",
      () => this.deleteAllErrorLogsRequest()
    );
  }

  public getPrettyCalculationName(calculationName: string): string{
    return ErrorLogsDisplayComponent.getPrettyCalculationName(calculationName);
  }

  public static getPrettyCalculationName(calculationName: string): string{
    switch (calculationName){
      case "TERRAIN_GRID":
        return "Terrain Grid";
      case PendingCalculationType.COVERAGE:
        return "Coverage";
      case PendingCalculationType.CUMULATIVE_COVERAGE:
        return "Cumulative Coverage";
      case PendingCalculationType.OVERLAP:
        return "Overlap";
      case "PERFORMANCE":
        return "Performance";
      case "NAVAID_SITING_TOOL":
        return "Navaid Siting Tool";
      case "PROCEDURE_ANALYSIS":
        return "Procedure Performance Analysis";
      case PendingCalculationType.VERTICAL_PROFILE:
        return "Procedure Vertical Profile";
      case "ROUTE_PERFORMANCE":
        return "Procedure Performance Report";
      case "HORIZON_TOOL":
        return "Horizon Tool";
      case "CROSS_SECTION":
        return "Cross Section";
      case "TERRAIN_ALTITUDE_CUT":
        return "Terrain Altitude Cut";
      case "Terrain_Resolution":
        return "Terrain Resolution";
      default:
        return calculationName;
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.close(false); // escape key already hides the modal
  }

  close(hideModal: boolean = true){
    this.errorLogsByCalcType = null;
    hideModal? this.bsModalRef.hide(): false;
  }








}
